
(function() {
	'use strict';

	angular
		.module('onboarding.common')
		.directive('tinTooltip', tinTooltip);

	function tinTooltip() {
		return {
			restrict: 'EA',
			scope: {
				tooltipTextCode: '@',
				tooltipTextDescription: '@'
			},
			replace: false,
			templateUrl: '/app/common/directives/tinTooltip.html',
			link: linkFunction
		};
	}

	function linkFunction(scope, element) {
		activate();

		function activate() {
			scope.isTooltipShown = false;

			element.bind('mouseover', function() {
				scope.$apply(function() {
					toggle();
				});
			});

			element.bind('mouseout', function() {
				scope.$apply(function() {
					toggle();
				});
			});
		}

		function toggle() {
			scope.isTooltipShown = !scope.isTooltipShown;
		}
	}
})();
